import { queryKey } from 'Shared/const/queryKey';
import { useTokenStore } from 'Shared/hooks/useTokenStore';
import { ViewingPlatform } from 'app/_entities/sns-account';
import { useSDQuery } from 'viewup-lib/react';

export const useNBlogAccountsStatus = () => {
  const { accessToken } = useTokenStore();
  const queryResult = useSDQuery({
    ...queryKey.viewingCommon.accounts,
    enabled: !!accessToken,
    gcTime: 5000,
    select: (data) => {
      const accounts = data.filter(
        (item) => item.viewingPlatform === ViewingPlatform.NBLOG && item.isApproved,
      );
      const errorAccountCount =
        accounts?.reduce((acc, cur) => {
          return acc + (cur?.accountError ? 1 : 0);
        }, 0) || 0;

      const hasNoAccounts = accounts.length === 0;

      return {
        errorAccountCount,
        hasNoAccounts,
      };
    },
    staleTime: 5000,
  });

  return queryResult;
};
